import { Components } from "@mui/material";

export const MuiList: Components["MuiList"] = {
  styleOverrides: {
    root: {
      padding: "0",
    },
  },
};
